import React from 'react';
import {useDropzone} from 'react-dropzone';
import { useState, useCallback } from "react";
import './FileUpload.css';

function FileUploadImageNouns(props) {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    let fileArray = [];
    const files = acceptedFiles.map(function(file) {
      if(file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpeg" || file.type === "video/mp4" || file.type === "video/quicktime" || file.type === "video/x-quicktime" || file.type === "video/avi") {
        fileArray.push(file);
      }
      return(
        file.type === "video/mp4" || file.type === "video/quicktime" || file.type === "video/x-quicktime" || file.type === "video/avi"
          ?
        <video className="max-h-96" key={file.path} controls playsInline>
          <source src={URL.createObjectURL(file)} type="video/mp4" />
        </video>
          :
        file.type === "image/png" || file.type === "image/jpeg"
          ?
        <img key={file.path} src={URL.createObjectURL(file)} className="max-h-96" />
          :
        null
      );
    }).filter(x => x);

    setFiles(files);
    props.setMedia(fileArray);
  }, []);
  const {getRootProps, getInputProps} = useDropzone({
    onDrop
  });

  return (
    <div>
      <div className="text-xl font-semibold text-gray-500 dark:text-zinc-500">
        Artwork files
      </div>
      {
        files.length === 0
          ?
        <div className="dark:bg-zinc-800 p-2 w-full flex justify-center items-center text-xl font-bold h-96 bg-gray-200 rounded-lg">
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            {
              files.length === 0
                ?
              <div>
                <div className="cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 bg-black dark:bg-white h-12 w-72 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer">
                  Upload Images (JPEG/PNG)
                </div>
              </div>
                :
              null
            }
          </div>
        </div>
          :
        <div className="dark:bg-zinc-800 p-2 w-full flex justify-center text-xl font-bold overflow-hidden overflow-scroll h-96 bg-gray-200 rounded-lg">
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <div className="grid grid-cols-3 gap-2">{files}</div>
          </div>
        </div>
      }
    </div>
  );
}

export default FileUploadImageNouns;
